module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation"
  }, [(_vm.currentMenu === "manager") ? _c('div', {
    staticClass: "choose-manager"
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Qui êtes-vous ?\n        ")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [(_vm.managers.length === 0 && _vm.isUpdating) ? _c('p', {
    staticClass: "text-xs-left pl-3"
  }, [_c('em', [_vm._v("Chargement...")])]) : (_vm.managers.length === 0 && !_vm.isUpdating) ? _c('p', {
    staticClass: "text-xs-left pl-3"
  }, [_c('em', [_vm._v("Pas de manager autorisé sur cette tablette")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.managers), function(manager) {
    return _c('span', {
      key: manager.id,
      on: {
        "click": function($event) {
          _vm.chooseManager(manager)
        }
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(manager.firstname) + " " + _vm._s(manager.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(manager.email))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentMenu === "survey") ? _c('div', {
    staticClass: "choose-survey"
  }, [(_vm.currentManager) ? _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    nativeOn: {
      "click": function($event) {
        _vm.goBackToManagerChoice($event)
      }
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), (_vm.currentManager.surveyStarts) ? _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Veuillez choisir une enquête dans la liste ci-dessous")]) : _c('p', [_vm._v("Pas d'enquête ouverte pour cet utilisateur")])], 1)]), _vm._v(" "), (_vm.currentManager.surveyStarts) ? _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.currentManager.surveyStarts), function(surveyStart) {
    return _c('span', {
      key: surveyStart.id,
      on: {
        "click": function($event) {
          _vm.chooseSurveyStart(surveyStart)
        }
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(surveyStart.survey.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enquête démarrée le " + _vm._s(_vm.moment(surveyStart.createdAt).format('DD/MM/YYYY')))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)], 1)
  })) : _vm._e()], 1)], 1) : _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', [_vm._v("Aucun manager selectionné")])], 1)])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentMenu === "participant") ? _c('div', {
    staticClass: "choose-participant"
  }, [(_vm.currentSurveyStart) ? _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left pb-0"
  }, [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    nativeOn: {
      "click": function($event) {
        _vm.goBackToSurveyChoice($event)
      }
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 mt-2 text-xs-center subheading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.currentManager.firstname) + " " + _vm._s(_vm.currentManager.lastname))]), _vm._v(", qui souhaitez-vous faire répondre ?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-3 mb-2"
  }, [_c('v-menu', {
    staticClass: "team-filter-menu",
    attrs: {
      "offset-y": ""
    }
  }, [(Object.keys(_vm.currentPossibleNodes).length > 2) ? _c('v-btn', {
    staticClass: "pa-1 pr-2",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Afficher les participants de : "), _c('em', [_vm._v(_vm._s(_vm.currentPossibleNodes[_vm.teamFilter]))]), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e(), _vm._v(" "), _c('v-list', _vm._l((_vm.currentPossibleNodes), function(label, node) {
    return _c('span', {
      key: node,
      staticClass: "team-filter-menu-item"
    }, [_c('v-list-tile', {
      attrs: {
        "disabled": _vm.teamFilter === node
      },
      on: {
        "click": function($event) {}
      },
      nativeOn: {
        "click": function($event) {
          _vm.teamFilter = node
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(label))])], 1), _vm._v(" "), _c('v-divider')], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.currentParticipants), function(participant) {
    return (participant.employee.id !== _vm.currentManager.id) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "disabled": participant.hasAnswered || participant.isDone
      },
      nativeOn: {
        "click": function($event) {
          _vm.chooseParticipant(participant)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(participant.employee.firstname) + " " + _vm._s(participant.employee.lastname))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(participant.node.label))])]), _vm._v(" "), (participant.employee.id === _vm.currentManager.id) ? _c('span', [_vm._v("Manager de: "), _c('em', [_vm._v(_vm._s(participant.node.label))])]) : (false && (participant.employee.email || participant.employee.phone)) ? _c('span', [_vm._v("Cet employé a reçu une invitation pour répondre")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [(participant.hasAnswered || participant.isDone) ? _c('v-icon', {
      staticClass: "green--text text--lighten-1"
    }, [_vm._v("check")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.nextMergedParticipants), function(info, nodeId) {
    return (!_vm.onTheFly || info.nbLeft > 0) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "disabled": info.nbLeft === 0
      },
      nativeOn: {
        "click": function($event) {
          _vm.chooseNextMergedParticipant(nodeId)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(info.node.label))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  " + _vm._s(info.nbDone) + "/" + _vm._s(info.nbTotal) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [(info.nbLeft === 0) ? _c('v-icon', {
      staticClass: "green--text text--lighten-1"
    }, [_vm._v("check")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.additionnalParticipants), function(participant) {
    return [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.chooseParticipant(participant)
        }
      }
    }, [_c('v-list-tile-avatar', [(participant.isAdditionnal) ? _c('v-icon', [_vm._v("person_add")]) : _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(participant.node.label))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [(participant.node.nbEmployeesWOEmail === 0) ? _c('span', [_vm._v("\n                    Participant supplémentaire\n                  ")]) : (_vm.nextMergedParticipants[participant.node.id]) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.nextMergedParticipants[participant.node.id].nbDone) + "/" + _vm._s(_vm.nextMergedParticipants[participant.node.id].nbTotal) + "\n                  ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)]
  })], 2)], 1)], 1) : _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', [_vm._v("Aucune enquête selectionnée")])], 1)])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40aa51d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 321
// module chunks = 1